import { PoolName } from "@/shared/constants/pools";
import { ChainName } from "@/shared/types/networks";

import {
  ArbitrumActiveGoerliPools,
  ArbitrumActivePools,
  PolygonActivePools,
} from "../constants/active-pools";
import {
  marginlyPoolArbUsdcArbitrum,
  marginlyPoolArbUsdcNativeArbitrum,
  marginlyPoolWbtcWethArbitrum,
  marginlyPoolWethUsdcArbitrum,
  marginlyPoolWethUsdcNativeArbitrum,
} from "../constants/pools/arbitrum";
import {
  marginlyPoolArbUsdcArbitrumGoerli,
  marginlyPoolGmxUsdcArbitrumGoerli,
  marginlyPoolWethUsdcArbitrumGoerli,
} from "../constants/pools/arbitrum-goerli";
import { marginlyPoolWethUsdcPolygonMumbai } from "../constants/pools/polygon-mumbai";
import { ParamsByBoolName, PoolParams } from "../types";

const paramsByPoolNameArbitrumGoerli: Record<
  ArbitrumActiveGoerliPools,
  PoolParams
> = {
  [PoolName.GmxUsdc]: marginlyPoolGmxUsdcArbitrumGoerli,
  [PoolName.ArbUsdc]: marginlyPoolArbUsdcArbitrumGoerli,
  [PoolName.WethUsdc]: marginlyPoolWethUsdcArbitrumGoerli,
};

const paramsByPoolNameArbitrum: Record<ArbitrumActivePools, PoolParams> = {
  [PoolName.ArbUsdc]: marginlyPoolArbUsdcArbitrum,
  [PoolName.WethUsdc]: marginlyPoolWethUsdcArbitrum,
  [PoolName.WbtcWeth]: marginlyPoolWbtcWethArbitrum,
  [PoolName.WethUsdce]: marginlyPoolWethUsdcNativeArbitrum,
  [PoolName.ArbUsdce]: marginlyPoolArbUsdcNativeArbitrum,
};

const paramsByPoolNamePolygonMumbai: Record<PolygonActivePools, PoolParams> = {
  [PoolName.WethUsdc]: marginlyPoolWethUsdcPolygonMumbai,
};

const poolsByChainName: Record<ChainName, ParamsByBoolName> = {
  [ChainName.Arbitrum]: paramsByPoolNameArbitrum,
  [ChainName.ArbitrumGoerli]: paramsByPoolNameArbitrumGoerli,
  [ChainName.PolygonMumbai]: paramsByPoolNamePolygonMumbai,
};

export const getPoolParams = (poolName: PoolName, chainName: ChainName) => {
  const pools = poolsByChainName[chainName];
  return pools[poolName];
};
